import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function HeadTags(){
  const { t, i18n } = useTranslation('common');

  useEffect(()=> {
    try {
      const nodes: HTMLMetaElement[] = [];
      const links: HTMLLinkElement[] = [];

      const ensureMeta = (name:string, content:string) => {
        let m = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
        if (!m) { 
          m = document.createElement('meta'); 
          m.name = name; 
          document.head.appendChild(m); 
          nodes.push(m);
        }
        m.content = content;
      };

      // локализованное описание
      ensureMeta('description', t('hero.subtitle'));
      ensureMeta('viewport', 'width=device-width, initial-scale=1');

      // ЗАДАЧА A: Build info for server/client sync validation
      const buildSha = import.meta.env.VITE_BUILD_SHA || 'dev';
      const envLabel = import.meta.env.VITE_ENV_LABEL || 'DEV';
      ensureMeta('build-sha', buildSha);
      ensureMeta('app-version', `${envLabel}-${buildSha}`);
      
      // Canonical link
      const ensureLink = (rel: string, href: string) => {
        let l = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
        if (!l) { 
          l = document.createElement('link'); 
          l.rel = rel; 
          document.head.appendChild(l); 
          links.push(l);
        }
        l.href = href;
      };
      
      ensureLink('canonical', window.location.origin + window.location.pathname);
      ensureLink('sitemap', `${window.location.origin}/sitemap.xml`);

      // hreflang (en/ru)
    const addAlt = (lng:'en'|'ru') => {
      const l = document.createElement('link');
      l.rel = 'alternate'; 
      l.hreflang = lng; 
      l.href = `${window.location.origin}?lng=${lng}`;
      document.head.appendChild(l); 
      links.push(l);
    };
    addAlt('en'); 
    addAlt('ru');

    // JSON-LD (без локализации имени организации — ок)
    const ldOrg = {
      '@context':'https://schema.org', '@type':'Organization',
      name:'Supabank', url:window.location.origin,
      logo: `${window.location.origin}/android-chrome-512x512.png`,
      sameAs:[
        'https://x.com/supabankxyz',
        'https://github.com/supabankxyz',
        'https://t.me/supabankxyz'
      ]
    };
    const ldSite = {
      '@context':'https://schema.org', '@type':'WebSite',
      name:'Supabank', url:window.location.origin,
      potentialAction: { '@type':'SearchAction', target:`${window.location.origin}/search?q={query}`, 'query-input':'required name=query' }
    };
    const ldBreadcrumb = {
      '@context':'https://schema.org', '@type':'BreadcrumbList',
      itemListElement:[{ '@type':'ListItem', position:1, name:'Home', item:window.location.origin }]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify([ldOrg, ldSite, ldBreadcrumb]);
    document.head.appendChild(script);

      return ()=> {
        nodes.forEach(n=> n.parentNode && document.head.removeChild(n));
        links.forEach(l=> l.parentNode && document.head.removeChild(l));
        if (script.parentNode) document.head.removeChild(script);
      };
    } catch (e) {
      console.error('HeadTags error:', e);
    }
  // перегенерируем мета при смене языка
  }, [i18n.language, t]);

  return null;
}